var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reset-password mb-12"},[_c('div',{staticClass:"reset-password__card"},[_c('h1',{staticClass:"white--text text-center mb-4"},[_vm._v("Nastavte si nové heslo")]),_c('div',{staticClass:"divider"}),_c('ResetPasswordForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }